import { defineMessages } from 'react-intl-next';

export const i18n: {
	externalPersonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	externalPersonLabel: {
		id: 'externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
});
